/**
 * Eara Account Login
 * Purpose: Standardize Shop login behavior and fix post-login page state
 */
class EaraAccountLogin extends HTMLElement {
  /** @type {HTMLElement | null} */
  #shopLoginButton = null;

  connectedCallback() {
    this.#shopLoginButton = this.querySelector('shop-login-button');

    if (!this.#shopLoginButton) {
      console.warn('[eara-account-login] shop-login-button not found');
      return;
    }

    this.#configureShopLogin();
    this.#bindEvents();
  }

  /**
   * Applies Eara-required attributes to Shop login button
   * We do this here because we don't control its markup
   */
  #configureShopLogin() {
    const button = this.#shopLoginButton;

    button.setAttribute('full-width', 'true');
    button.setAttribute('persist-after-sign-in', 'true');

    // Assumption: Eara ONLY uses New Customer Accounts
    button.setAttribute('analytics-context', 'eara_login_self_serve');
    button.setAttribute('flow-version', 'eara-account-popover');
    button.setAttribute('return-uri', window.location.href);
  }

  /**
   * Ensures page state is correct after authentication
   */
  #bindEvents() {
    this.#shopLoginButton.addEventListener('completed', this.#handleLoginComplete);
  }

  #handleLoginComplete = () => {
    // Brutal but necessary — state is wrong otherwise
    window.location.reload();
  };
}

if (!customElements.get('eara-account-login')) {
  customElements.define('eara-account-login', EaraAccountLogin);
}
